import React, { useEffect, useRef, useState } from "react";
import { StyleProp, View, ViewStyle } from "react-native";
import { useDragDropContext } from "../../../utilities/drag-drop";
import { PageItemType } from "../../../utilities/layout";
import { useIsMounted } from "../../../utilities/use-is-mounted";

export type DropZoneProps = {
  onEnter?: () => void;
  onLeave?: () => void;
  onDrop?: (data?: any) => void;
  id: string;
  style?: StyleProp<ViewStyle>;
  disabled?: boolean;
  children?: React.ReactNode;
};

export function DropZone(props: DropZoneProps) {
  const isMounted = useIsMounted();
  const ref = useRef<View>(null);
  const timerRef = useRef<NodeJS.Timer | null>(null);

  const {
    controllers: { zoneController },
  } = useDragDropContext();

  const [active, setActive] = useState<boolean>(false);

  const { onEnter, onLeave, onDrop, id, disabled, children, style } = props;

  function handleEnter({ x, y }: { x?: number; y?: number }) {
    if (disabled) return;
    if (!active) {
      // setActive(true);
    }
    if (onEnter) onEnter();
  }

  function handleLeave() {
    if (disabled) return;
    if (onLeave) onLeave();
  }

  function handleDrop(item: PageItemType) {
    if (disabled) return;
    if (onDrop) onDrop(item);
    setActive(false);
  }

  function reportMeasurements() {
    ref.current?.measure((_, __, width, height, x, y) => {
      if (isMounted.current) {
        zoneController.updateZone({
          id,
          width,
          height,
          x,
          y,
          ref: ref.current,
          onEnter: handleEnter,
          onLeave: handleLeave,
          onDrop: handleDrop,
        });
      } else {
        zoneController.removeZone(id);
      }
    });
  }

  function startReporting() {
    reportMeasurements();
    timerRef.current = setInterval(reportMeasurements, 1000);
  }

  function stopReporting() {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    zoneController.removeZone(id);
  }

  // report measurements on component updates
  useEffect(() => {
    reportMeasurements();
  });

  useEffect(() => {
    // report measurements every second regardless of updates
    startReporting();
    return stopReporting;
  }, [id]);

  return (
    <View style={style} onLayout={reportMeasurements} ref={ref}>
      {children}
    </View>
  );
}
